/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import Image from 'next/image';
import { getOrganizationPropertiesByHost } from '../../../utils/helpers';
import Centres from './Centres';
import Tags from './Tags';
import CoursesCard from '../../shared/CoursesCard';
import Spinner from '../../shared/spinner';
import ViewAllButton from './ViewAllButton';
import BottomSheetCard from '../../shared/BottomSheetCard';
import MapSvg from '../icons/map.svg';
import DropdownArrowSVG from '../icons/dropdown-arrow.svg';
import HorizontalScroll from '../../shared/HorizontalScroll';
import { useMiscellaneousData } from '../../../contexts/ssr-miscellaneous-context';

function OfflineCourses({
  centerSelected,
  refetchOfflineCourses, heading, offlineData,
  offlineLoading,
  initialTagsData,
  initialCentersData,
  // eslint-disable-next-line no-unused-vars
  order,
}) {
  const [offlineTagSelected, setOfflineTagSelectd] = useState('');
  const { miscellaneousData } = useMiscellaneousData();
  const [centerID, setCenterID] = useState(centerSelected);
  // console.log('centerDefaultSelect', centerSelected);
  const [isCenterClick, setIsCenterClick] = useState(false);
  const [mobileCurrentCentreName, setMobileCurrentCereName] = useState('Delhi');

  const currentOrg = getOrganizationPropertiesByHost(miscellaneousData?.hostname);
  const organizationId = currentOrg?.orgId || '2410f924-6cc4-4e88-b490-ffd3bbc40d03';
  const handleChangeCenter = (centerid) => {
    // console.log('centerid', centerid);
    setCenterID(centerid);
    refetchOfflineCourses({
      variables: {
        orgId: organizationId,
        filters: [
          {
            key: 'centreId',
            value: centerid,
          },
          {
            key: 'tagId',
            value: offlineTagSelected,
          },
          {
            key: 'mode',
            value: 'Offline', // TODO
          },
        ],
      // fetchPolicy: 'cache-first',
      },
    });
  };
  const handleTagsCourse = (tagType, tagId) => {
    // console.log('taaaap', tagType, tagId);
    setOfflineTagSelectd(tagId === 'all' ? '' : tagId);
    refetchOfflineCourses({
      variables: {
        orgId: organizationId,
        filters: [
          {
            key: 'centreId',
            value: centerID,
          },
          {
            key: 'tagId',
            value: tagId === 'all' ? '' : tagId,
          },
          {
            key: 'mode',
            value: 'Offline', // TODO
          },
        ],
      // fetchPolicy: 'cache-first',
      },
    });
    // console.log('netwo4rk status ', onlineNetworkStatus, offlineNetworkStatus);
  };

  const handleClose = () => {
    setIsCenterClick(false);
  };
  const handleMobileCurrentName = (value) => {
    setMobileCurrentCereName(value);
  };

  return (
    <div>
      <div className="flex justify-between items-center lg:mb-7 mb-4 pt-4">
        <h2 className="text-base lg:text-2xl font-semibold flex flex-col">
          {/*  eslint-disable-next-line eqeqeq */}
          {/* {order == 1
                && <span className="text-sm lg:text-xl font-semibold text-customBlue">Our Courses</span>} */}
          {heading}
        </h2>
        <div className="hidden lg:block">
          <Centres
            initialCentersData={initialCentersData}
            organizationId={organizationId}
            defaultSelectData={centerSelected}
            handleChangeCenter={handleChangeCenter}
          />
        </div>
        <div
          className="flex tab-btn px-4 py-2 border-2
    text-sm font-normal text-gray-700 rounded-full
    cursor-pointer whitespace-nowrap bg-thinBlue items-center justify-center mr-5 lg:hidden"
          onClick={() => setIsCenterClick(true)}
        >
          <Image width={18} height={18} src={MapSvg} className="text-customBlue mr-1" alt="mapicons" />
          <span className="text-customBlue font-medium">{mobileCurrentCentreName}</span>
          <Image width={20} height={20} src={DropdownArrowSVG} className="text-customBlue" alt="DropdownArrowSVG" />
        </div>
      </div>
      { isCenterClick
    && (
    <BottomSheetCard
      title="Choose Centre"
      isOpen={isCenterClick}
      onClose={handleClose}
      initialHeight="60%"
      pageName="home page"
    >
      <Centres
        initialCentersData={initialCentersData}
        organizationId={organizationId}
        defaultSelectData={centerID}
        handleChangeCenter={handleChangeCenter}
        isMobile={isCenterClick}
        handleClose={handleClose}
        handleMobileCurrentName={handleMobileCurrentName}
      />
    </BottomSheetCard>
    )}

      {/* Filters */}
      {/* {getTagsOnline(responseData.getOrganizationById.tags)} */}
      <div className="flex justify-between items-center mb-4">
        <div className="w-full lg:w-[90%]">

          <HorizontalScroll rightSpace="lg:-right-7 right-1">
            <Tags
              organizationId={organizationId}
              typeTags="offline"
              handleTagsCourse={handleTagsCourse}
              centerChange={centerID}
              initialTagsData={initialTagsData}
            />
          </HorizontalScroll>
        </div>

        <div className="mb-6 lg:mb-0">
          <ViewAllButton
            pageUrl="/all-courses"
            queryString={`?mode=${'Offline'}&centreId=${centerID}&tag=${offlineTagSelected || 'all'}`}
            typeButton={2}
          />
        </div>

      </div>

      {/* Course Cards */}
      {!offlineLoading
        ? (
          <>
            <HorizontalScroll className="gap-2">
              <CoursesCard
                page="course"
                data={offlineData?.getCourses}
                otherProp="hello"
                wrapperClasses="flex gap-4 lg:grid-cols-3 gap-4 px-0"
              />
            </HorizontalScroll>

            {/* {offlineData?.getCourses.length ? ( */}
            <div className="lg:hidden mt-8 ">
              <ViewAllButton
                pageUrl="/all-courses"
                queryString={`?mode=${'Offline'}&centreId=${centerID}&tag=${offlineTagSelected || 'all'}`}
              />
            </div>
            {/* ) : ''} */}
          </>
        )
        : <div className="min-h-80 flex justify-center items-center"><Spinner /></div>}

    </div>
  );
}

export default OfflineCourses;
